import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Menu, Row, Col, Button } from 'antd';
import {
  PoweroffOutlined,
  UserOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';

import { useTenant } from '../../context/useTenant';
import { useUser } from '../../context/useUser';

import AuthStore from '../../stores/Auth';
import { canSwitchOperation } from '../../shared/auth/operations';

import TenantIdComponent from '../Common/Tenant/Id';
import SupportFloatButton from '../Common/Support/SupportFloatButton';
import HelperPopup from '../Common/Popup/HelperPopup';
import MaintenanceBanner from '../Common/Maintenance/MaintenanceBanner';

const { Header } = Layout;

const HeaderComponent = () => {
  const { user, scope, meta, acl } = AuthStore.getAuthenticated();
  const operacao = scope ? scope.scope : null;
  const { client_id } = useParams();
  const { handleTenantData, tenantData } = useTenant();
  const { operationsList } = useUser();
  const [tenantDomain, setTenantDomain] = useState('');

  useEffect(() => {
    if (operacao) {
      handleTenantData(operacao);
    }
  }, [operacao]);

  useEffect(() => {
    if (tenantData) {
      const { origins } = tenantData;
      setTenantDomain(origins?.[0]);
    }
  }, [tenantData]);

  const menuItems = useMemo(() => {
    const items = [
      {
        key: 'ops:content',
        label: <Link to={`/${client_id}/content`}>Studio</Link>,
      },
    ];

    if (tenantData?.profile?.products?.includes('beon_search')) {
      items.push({
        key: 'ops:search',
        label: <Link to={`/${client_id}/search`}>Busca</Link>,
      });
    }

    items.push({
      key: 'ops:catalog',
      className: 'app-header__menu-divider',
      label: <Link to={`/${client_id}/catalog`}>Catálogo</Link>,
    });

    const accountChildren = [];

    if (canSwitchOperation(acl, operationsList)) {
      accountChildren.push({
        key: 'account:change-operation',
        label: (
          <Link to="/login">
            <SwapOutlined /> Trocar operação
          </Link>
        ),
      });
    }

    accountChildren.push({
      key: 'account:logout',
      label: (
        <Link to="/logout">
          <PoweroffOutlined /> Logout
        </Link>
      ),
    });

    items.push({
      key: 'account',
      icon: <UserOutlined />,
      label: meta ? meta.fullname : user,
      children: accountChildren,
    });

    if (operacao) {
      items.push({
        key: 'organization',
        label: <TenantIdComponent tenantData={tenantData} />,
      });
    }

    return items;
  }, [
    acl,
    client_id,
    meta,
    operacao,
    operationsList,
    tenantData,
    user,
  ]);

  return (
    <>
      <Header className="app-header">
        <Row gutter={0}>
          <Col span={4}>
            <span className="app-header__logo">Beonly</span>
          </Col>

          <Col span={16}>
            <Menu
              key="ops"
              mode="horizontal"
              theme="dark"
              defaultSelectedKeys={['ops:content']}
              className="app-header__menu"
              items={menuItems}
            />
          </Col>

          <Col span={4} className="app-header__preview-col">
            <Button className="preview-site-btn">
              <a href={`${tenantDomain}?beonly-debug`} target="_blank">
                Pré-visualizar o site
              </a>
            </Button>
            <HelperPopup
              mode={'icon'}
              key="preview-helper"
              url={
                'https://beonly.notion.site/Pr-visualizar-o-site-113843ff413080a7b8a5dfb288127c32'
              }
            />
          </Col>
        </Row>
      </Header>

      <SupportFloatButton />

      <MaintenanceBanner />
    </>
  );
};

export default HeaderComponent;
